// import { PlaceMedia } from './get'


export const URL = '/v2/pms/accomodations/:placeId/media/reorder/'

export type Req = {
  ids: number[]
}

export type Resp = any